
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trail-series",
      function () {
        return require("private-next-pages/trail-series/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trail-series"])
      });
    }
  